import {
  Battery0Bar as Battery0Icon,
  Battery20 as Battery20Icon,
  Battery50 as Battery50Icon,
  Battery80 as Battery80Icon,
  BatteryFull as BatteryFullIcon,
  Power as PowerIcon,
} from "@mui/icons-material";
import { Chip } from "@mui/material";
import React from "react";

import { getDeviceBatteryDisplay, type DeviceBatteryIcon } from "@/utils/deviceBattery";
import { formatPercentFromWhole } from "@/utils/number";

interface DeviceBatteryChipProps {
  device: {
    batteryPercent?: number;
    operatingSystemType?: string;
    type: string;
  };
  locale: string;
  wallPowerLabel: string;
}

const renderBatteryIcon = (icon: DeviceBatteryIcon) => {
  switch (icon) {
    case "battery0":
      return <Battery0Icon />;
    case "battery20":
      return <Battery20Icon />;
    case "battery50":
      return <Battery50Icon />;
    case "battery80":
      return <Battery80Icon />;
    case "power":
      return <PowerIcon />;
    default:
      return <BatteryFullIcon />;
  }
};

/** Shared battery chip for Device List and Command Center. */
export const DeviceBatteryChip: React.FC<DeviceBatteryChipProps> = ({
  device,
  locale,
  wallPowerLabel,
}) => {
  const batteryDisplay = getDeviceBatteryDisplay(device);

  if (!batteryDisplay || device.batteryPercent === undefined) {
    return null;
  }

  return (
    <Chip
      size="small"
      color={batteryDisplay.color}
      icon={renderBatteryIcon(batteryDisplay.icon)}
      label={
        batteryDisplay.isPluggedIn
          ? wallPowerLabel
          : formatPercentFromWhole(device.batteryPercent, locale)
      }
    />
  );
};
